import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from './api/apiSlice';
// import { setupListeners } from "@reduxjs/toolkit/dist/query";
import authReducer from '../features/auth/authSlice';


export const store = configureStore({
    reducer: {
      [apiSlice.reducerPath]: apiSlice.reducer,
      auth: authReducer,

    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(apiSlice.middleware),
    devTools: true,
    // process.env.NODE_ENV !== 'production'
  });